import type { BadgeVariants } from "@/components/ui/badge";

export const M_CAMPAIGN_STATUS_VARIANTS: Record<string, BadgeVariants["variant"]> = {
  draft: "info",
  pending: "warning",
  active: "success",
  paused: "warning",
  complete: "neutral",
  error: "danger",
};
